import { useEsignTaskPrefill } from '@commenda/api/docusign';
import { RequestSignatureModal } from '../../../docusign/RequestSignatureModal';
import { TCommonTaskProp } from '../../../types';

interface AdHocSignatureTaskModalProps {
  isOpen: boolean;
  onClose: () => void;
  taskId: number;
  serviceRequest: TCommonTaskProp['context']['serviceRequest'];
  onSent: () => void;
}

/**
 * The ad-hoc HUMAN_ESIGN send flow: the one-off request modal, opened on the
 * document the step's upstream generating step produced. The assignee can pick or
 * upload a different one, and places the signature fields in the provider's sender
 * view as usual.
 */
export const AdHocSignatureTaskModal = ({
  isOpen,
  onClose,
  taskId,
  serviceRequest,
  onSent,
}: AdHocSignatureTaskModalProps) => {
  const { prefill, isLoading, error } = useEsignTaskPrefill(
    isOpen ? taskId : null
  );

  // Opening on an empty picker and popping the document in a moment later reads as a
  // glitch, so the modal waits. A failed lookup still opens it — the assignee supplies
  // the document themselves.
  if (!serviceRequest || (isLoading && !error)) return null;

  const sourceDocument =
    prefill?.mode === 'ad_hoc' ? prefill.sourceDocument : undefined;

  return (
    <RequestSignatureModal
      mode="workflow-task"
      isOpen={isOpen}
      onClose={onClose}
      serviceRequest={serviceRequest}
      companyId={serviceRequest.companyId ?? null}
      serviceRequestTaskId={taskId}
      presetFileId={sourceDocument?.fileId}
      onSuccess={onSent}
    />
  );
};
